import React, { useEffect, useReducer, useState } from "react";
import { 
    Box, Container, Grid, TextField, Typography, Checkbox, 
    Link, Button, MenuItem, IconButton, Avatar, Chip, 
    LinearProgress, CssBaseline, Card 
} from "@mui/material";

import { useHistory } from "react-router-dom";
import { LoadingButton } from "@mui/lab";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faBuilding, faMapLocationDot } from "@fortawesome/free-solid-svg-icons";

// Componentes y Controladores
import { companySignUp } from "../../controllers/AuthController";
import { GetToSearchMerchants } from "../../controllers/MerchantsController";
import ResponseComponent from "../../components/responseComponent";
import QUDProgress from "../../components/progress";
import PhoneInput from "react-phone-input-2";
import ReCaptchaGoogle from "../../components/ReCaptchaGoogle";
//import "react-phone-input-2/lib/style.css"; // Asegurar estilos del teléfono
import 'react-phone-input-2/lib/material.css'
import logo from '../../assets/images/logos/black.png';

// Imágenes de países
import chile from '../../assets/images/countries/chile.png';
import colombia from '../../assets/images/countries/colombia.png';
import venezuela from '../../assets/images/countries/venezuela.png';
import usa from '../../assets/images/countries/usa.png';
import elsalvador from '../../assets/images/countries/elsalvador.png';

const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

// ESTADOS INICIALES
const initialState = {
    countries: [], cities: [], categories: [],
    country: null, city: '',

    name: '', errorName: false,
    lastName: '', errorLastName: false,
    documentType: '', errorDocumentType: false,
    documentNumber: '', errorDocumentNumber: false,
    phone: '', errorPhone: false,
    category: '', errorCategory: false,
    description: '', errorDescription: false,
    
    email: '', errorEmail: false,
    password: '', errorPassword: false,
    passwordConfirm: '', errorPasswordConfirm: false,
    agree: false, errorAgree: false,
    
    isLoading: false,
    isOpen: false, success: false, message: '', title: '',
    reCaptcha: ''
};

function reducer(state, { field, value }) {
    return { ...state, [field]: value };
}

export default function CompanySignUp() {
    const [step, setStep] = useState(0);
    const [citiesAux, setCitiesAux] = useState([]);
    const [state, setState] = useReducer(reducer, initialState);
    const history = useHistory();

    const {
        country, cities, categories, city,
        name, errorName, lastName, errorLastName,
        documentType, errorDocumentType, documentNumber, errorDocumentNumber,
        phone, errorPhone, category, errorCategory, description, errorDescription,
        email, errorEmail, password, errorPassword, passwordConfirm, errorPasswordConfirm,
        agree, errorAgree, isLoading, isOpen, title, message, success, reCaptcha
    } = state;

    const paises = [
        { id: 1, nombre: 'Venezuela', simbolo: 've', imagen: venezuela },
        //{ id: 2, nombre: 'Colombia', simbolo: 'co', imagen: colombia },
        //{ id: 3, nombre: 'Chile', simbolo: 'cl', imagen: chile },
        //{ id: 4, nombre: 'USA', simbolo: 'us', imagen: usa },
        //{ id: 5, nombre: 'El Salvador', simbolo: 'sv', imagen: elsalvador },
    ];

    const paisesDocumentos = [
        { idPais: 1, nombre: 'RIF (J)', valor: 'J' },
        { idPais: 1, nombre: 'Cédula Venezolana (V)', valor: 'V' },
        { idPais: 1, nombre: 'Cédula Extranjera (E)', valor: 'E' },
        { idPais: 2, nombre: 'NIT', valor: 'NIT' },
        { idPais: 2, nombre: 'Cédula Ciudadanía (CC)', valor: 'CC' },
        { idPais: 2, nombre: 'Cédula Extranjería (CE)', valor: 'CE' },
        { idPais: 3, nombre: 'RUT', valor: 'RUT' },
        { idPais: 4, nombre: 'EIN', valor: 'EIN' },
        { idPais: 4, nombre: 'SSN', valor: 'SSN' },
        { idPais: 5, nombre: 'DUI', valor: 'DUI' },
        { idPais: 5, nombre: 'NIF', valor: 'NIF' },
    ];

    useEffect(() => { handleGetToSearchMerchants(); }, []);

    const onChange = (e) => setState({ field: e.target.name, value: e.target.value });
    const redirect = (route) => history.push(route);

    const handleGetToSearchMerchants = async () => {
        let response = await GetToSearchMerchants();
        if (response.success) {
            setState({ field: 'categories', value: response.data.categories || [] });
            if (response.data.locations && Array.isArray(response.data.locations)) {
                const allCities = response.data.locations.flatMap(c => c.cities);
                setState({ field: 'cities', value: allCities });
            }
        }
    };

    // --- VALIDACIONES POR PASO ---
    const formVerificationStep2 = () => {
        let ban = 0;
        if (name === '') { setState({ field: 'errorName', value: true }); ban = 1; }
        if (lastName === '') { setState({ field: 'errorLastName', value: true }); ban = 1; }
        if (documentType === '') { setState({ field: 'errorDocumentType', value: true }); ban = 1; }
        if (documentNumber === '') { setState({ field: 'errorDocumentNumber', value: true }); ban = 1; }
        if (phone.length < 11) { setState({ field: 'errorPhone', value: true }); ban = 1; }
        return ban;
    };

    const formVerificationStep3 = () => {
        let ban = 0;
        if (category === '') { setState({ field: 'errorCategory', value: true }); ban = 1; }
        if (description === '') { setState({ field: 'errorDescription', value: true }); ban = 1; }
        return ban;
    };

    const formVerificationFinal = () => {
        let ban = 0;
        if (email === '' || !emailReg.test(email)) { setState({ field: 'errorEmail', value: true }); ban = 1; }
        if (password === '') { setState({ field: 'errorPassword', value: true }); ban = 1; }
        if (passwordConfirm === '' || password !== passwordConfirm) { setState({ field: 'errorPasswordConfirm', value: true }); ban = 1; }
        if (!agree) { setState({ field: 'errorAgree', value: true }); ban = 1; }
        return ban;
    };

    const handleNext = () => {
        if (step === 2 && formVerificationStep2() === 0) setStep(step + 1);
        if (step === 3 && formVerificationStep3() === 0) setStep(step + 1);
    };

    const handlePrevious = () => setStep(step - 1);

    const handleSubmit = async () => {
        if (formVerificationFinal() === 1) return;
            
        setState({ field: 'isLoading', value: true });
        let response = await companySignUp(name, lastName, documentType, documentNumber, phone, category, description, city.idCiudad, email, password);
        
        setState({ field: 'title', value: response.success ? '¡Operación Exitosa!' : 'Operación Fallida' });
        setState({ field: 'message', value: response.message || 'Error al procesar la solicitud' });
        setState({ field: 'success', value: response.success });
        setState({ field: 'isOpen', value: true });
        setState({ field: 'isLoading', value: false });
    };

    const handleCloseModal = () => {
        setState({ field: 'isOpen', value: false });
        if (success) redirect('/auth/signIn');
    };

    // --- SELECCIONES ---
    const handleSetCountry = (item) => {
        setState({ field: 'country', value: item });
        const _cities = cities.filter(c => c.idPais === item.id);
        setCitiesAux(_cities);
        setState({ field: 'documentType', value: '' });
        setState({ field: 'documentNumber', value: '' });
        setStep(1);
    };

    const handleSetCity = (item) => {
        setState({ field: 'city', value: item });
        setStep(2);
    };

    const handleOnChangeRecaptcha = (value) => {
        setState({ field: 'reCaptcha', value: value });
    };

    const handleOnExpiredRecaptcha = () => {
        setState({ field: 'reCaptcha', value: '' });
    };

    const progressPercentage = (step / 4) * 100;

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#ffffff', py: 4, px: 2 }}>
            <CssBaseline />
            
            <Container maxWidth="sm" disableGutters sx={{ m: 'auto' }}>
                
                {/* --- BARRA DE PROGRESO --- */}
                <Box sx={{ mb: 4, px: 2 }}>
                    <Box display="flex" justifyContent="space-between" mb={1}>
                        <Typography variant="caption" fontWeight="bold" color="text.secondary" textTransform="uppercase">
                            Paso {step + 1} de 5
                        </Typography>
                        <Typography variant="caption" fontWeight="bold" color="primary.main">
                            {progressPercentage}%
                        </Typography>
                    </Box>
                    <LinearProgress variant="determinate" value={progressPercentage} sx={{ height: 6, borderRadius: 3, bgcolor: '#f0f0f0' }} />
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                    
                    {/* --- LOGO --- 
                    <Box sx={{ mb: 3 }}>
                        <img src={logo} alt="ATE Logo" style={{ width: 60, height: 'auto' }} />
                    </Box>*/}

                    {/* --- TÍTULO PRINCIPAL --- */}
                    <Typography variant="h4" fontWeight="800" color="#111" textAlign="center" gutterBottom>
                        {step === 0 && "Elige tu país"}
                        {step === 1 && "Selecciona tu ciudad"}
                        {step === 2 && "Datos de tu negocio"}
                        {step === 3 && "¿A qué se dedica tu negocio?"}
                        {step === 4 && "Crea tus credenciales"}
                    </Typography>
                    
                    <Typography variant="body1" color="text.secondary" textAlign="center" mb={4}>
                        {step === 0 && "Selecciona el país donde operará tu comercio."}
                        {step === 1 && "Indícanos en qué ciudad ofreces tus servicios."}
                        {step === 2 && "Dinos cómo se llama tu empresa y sus datos legales."}
                        {step === 3 && "Ayuda a tus clientes a encontrarte fácilmente."}
                        {step === 4 && "Con estos datos ingresarás a tu panel de administración."}
                    </Typography>

                    {/* --- BREADCRUMBS (CHIPS) DE CONTEXTO --- */}
                    {step > 0 && (
                        <Box sx={{ display: 'flex', gap: 1, mb: 4, flexWrap: 'wrap', justifyContent: 'center' }}>
                            {country && (
                                <Chip 
                                    avatar={<Avatar src={country.imagen} />} 
                                    label={country.nombre} 
                                    onDelete={() => setStep(0)} 
                                    sx={{ fontWeight: 'bold', bgcolor: '#f8f9fa', border: '1px solid #e0e0e0' }}
                                />
                            )}
                            {city && step > 1 && (
                                <Chip 
                                    icon={<FontAwesomeIcon icon={faMapLocationDot} style={{ paddingLeft: '8px' }} />} 
                                    label={city.nombre} 
                                    onDelete={() => setStep(1)} 
                                    sx={{ fontWeight: 'bold', bgcolor: '#f8f9fa', border: '1px solid #e0e0e0' }}
                                />
                            )}
                        </Box>
                    )}

                    {/* --- CONTENIDO DEL FORMULARIO --- */}
                    <Box component="form" noValidate sx={{ width: '100%' }}>
                        
                        {/* PASO 0: PAÍS */}
                        {step === 0 && (
                            <Grid container spacing={2} justifyContent="center">
                                {paises.map(item => (
                                    <Grid item xs={6} sm={4} key={item.id}>
                                        <Card 
                                            onClick={() => handleSetCountry(item)}
                                            sx={{ 
                                                display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3, 
                                                cursor: 'pointer', border: '2px solid #f0f0f0', borderRadius: 4, boxShadow: 'none',
                                                transition: '0.2s', '&:hover': { borderColor: 'primary.main', bgcolor: 'primary.50', transform: 'translateY(-3px)' }
                                            }}
                                        >
                                            <img style={{ width: 60, height: 'auto', marginBottom: '12px', borderRadius: '4px' }} src={item.imagen} alt={item.nombre} />
                                            <Typography fontWeight="bold" color="#333">{item.nombre}</Typography>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        )}

                        {/* PASO 1: CIUDAD */}
                        {step === 1 && (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, justifyContent: 'center' }}>
                                {citiesAux.map(item => (
                                    <Chip
                                        key={item.idCiudad}
                                        label={item.nombre}
                                        onClick={() => handleSetCity(item)}
                                        sx={{ 
                                            px: 2, py: 2.5, fontSize: '1rem', fontWeight: '500', borderRadius: 8,
                                            border: '1px solid #e0e0e0', bgcolor: '#fff',
                                            '&:hover': { bgcolor: '#222', color: '#fff', borderColor: '#222' }
                                        }}
                                    />
                                ))}
                            </Box>
                        )}

                        {/* PASO 2: DATOS DEL NEGOCIO */}
                        {step === 2 && (
                            <Grid container spacing={2.5}>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Razón Social (Nombre Legal)</Typography>
                                    <TextField
                                        fullWidth name='name' placeholder='Ej: Inversiones ABC, C.A.' variant="outlined"
                                        value={name} onChange={onChange} onBlur={() => setState({ field: 'errorName', value: name === '' })}
                                        error={errorName} helperText={errorName && 'Requerido'}
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Nombre Comercial</Typography>
                                    <TextField
                                        fullWidth name='lastName' placeholder='Ej: Burger King' variant="outlined"
                                        value={lastName} onChange={onChange} onBlur={() => setState({ field: 'errorLastName', value: lastName === '' })}
                                        error={errorLastName} helperText={errorLastName && 'Requerido'}
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Tipo de Documento</Typography>
                                    <TextField
                                        select fullWidth name="documentType" value={documentType} onChange={onChange}
                                        onBlur={() => setState({ field: 'errorDocumentType', value: documentType === '' })}
                                        error={errorDocumentType} helperText={errorDocumentType && 'Requerido'}
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                                    >
                                        {paisesDocumentos.filter(i => i.idPais === country.id).map((item, idx) => (
                                            <MenuItem key={idx} value={item.valor}>{item.nombre}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Número de Documento</Typography>
                                    <TextField
                                        fullWidth name="documentNumber" placeholder="Ej: 12345678"
                                        InputProps={{
                                            startAdornment: documentType && <Typography fontWeight="bold" color="text.secondary" sx={{ mr: 1 }}>{documentType}-</Typography>
                                        }}
                                        value={documentNumber} onChange={onChange}
                                        onBlur={() => setState({ field: 'errorDocumentNumber', value: documentNumber === '' })}
                                        error={errorDocumentNumber} helperText={errorDocumentNumber && 'Requerido'}
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Teléfono del Comercio</Typography>
                                    <Box sx={{ '.react-tel-input .form-control': { width: '100%', height: '56px', borderRadius: '12px', borderColor: errorPhone ? '#d32f2f' : '#c4c4c4' } }}>
                                        <PhoneInput
                                            country={country?.simbolo} value={phone}
                                            onChange={(e) => { setState({ field: 'phone', value: e }); setState({ field: 'errorPhone', value: e.length < 10 }); }}
                                            onBlur={() => setState({ field: 'errorPhone', value: phone.length < 10 })}
                                        />
                                    </Box>
                                    {errorPhone && <Typography variant="caption" color="error.main" sx={{ mt: 0.5, display: 'block' }}>Teléfono inválido</Typography>}
                                </Grid>
                            </Grid>
                        )}

                        {/* PASO 3: CATEGORÍA Y DESCRIPCIÓN */}
                        {step === 3 && (
                            <Grid container spacing={2.5}>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Categoría del Negocio</Typography>
                                    <TextField
                                        select fullWidth name='category' placeholder='Selecciona una Categoría'
                                        value={category} onChange={onChange}
                                        onBlur={() => setState({ field: 'errorCategory', value: category === '' })}
                                        error={errorCategory} helperText={errorCategory && 'Requerido'}
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                                    >
                                        {categories.map((item) => (
                                            <MenuItem key={item.idcategoria} value={item.idcategoria}>{item.nombre}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Descripción Pública</Typography>
                                    <TextField
                                        fullWidth name="description" placeholder="Ej: Somos una empresa dedicada a..."
                                        multiline rows={5} value={description} onChange={onChange}
                                        onBlur={() => setState({ field: 'errorDescription', value: description === '' })}
                                        error={errorDescription} helperText={errorDescription && 'Requerido'}
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                                    />
                                </Grid>
                            </Grid>
                        )}

                        {/* PASO 4: CREDENCIALES (LOGIN) */}
                        {step === 4 && (
                            <Grid container spacing={2.5}>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Correo de Acceso (Admin)</Typography>
                                    <TextField
                                        fullWidth name='email' placeholder="admin@empresa.com"
                                        value={email} onChange={onChange}
                                        onBlur={() => setState({ field: 'errorEmail', value: email === '' })}
                                        error={errorEmail} helperText={errorEmail && 'Requerido'}
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Contraseña</Typography>
                                    <TextField
                                        fullWidth name='password' type="password" placeholder="••••••••"
                                        value={password} onChange={onChange}
                                        onBlur={() => setState({ field: 'errorPassword', value: password === '' })}
                                        error={errorPassword} helperText={errorPassword && 'Requerido'}
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Confirmar Contraseña</Typography>
                                    <TextField
                                        fullWidth name='passwordConfirm' type="password" placeholder="••••••••"
                                        value={passwordConfirm} onChange={onChange}
                                        onBlur={() => setState({ field: 'errorPasswordConfirm', value: passwordConfirm === '' || passwordConfirm !== password })}
                                        error={errorPasswordConfirm} helperText={passwordConfirm !== password && passwordConfirm !== '' ? 'No coinciden' : (errorPasswordConfirm && 'Requerido')}
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                                    />
                                </Grid>

                                {/* Términos */}
                                <Grid item xs={12} sx={{ mt: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <Checkbox
                                            checked={agree} onChange={() => setState({ field: 'agree', value: !agree })}
                                            sx={{ pt: 0, pl: 0, color: errorAgree ? 'error.main' : 'primary.main' }}
                                        />
                                        <Typography variant="body2" color={errorAgree ? 'error.main' : 'text.secondary'} sx={{ lineHeight: 1.5 }}>
                                            Declaro que he leído y acepto las{' '}
                                            <Link href='https://qud.life/privacy' target='_blank' sx={{ color: 'primary.main', fontWeight: 'bold', textDecoration: 'none' }}>Políticas</Link> y{' '}
                                            <Link href='https://qud.life/termsandconditions' target='_blank' sx={{ color: 'primary.main', fontWeight: 'bold', textDecoration: 'none' }}>Términos</Link>{' '}
                                            de ATE. 
                                        </Typography>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <ReCaptchaGoogle onChange={handleOnChangeRecaptcha} onAbort={handleOnExpiredRecaptcha} onExpired={handleOnExpiredRecaptcha} />
                                </Grid>
                            </Grid>
                        )}

                        {/* --- BOTONERA DE NAVEGACIÓN --- */}
                        <Box sx={{ display: 'flex', gap: 2, mt: 4, pt: 3, borderTop: '1px solid #f0f0f0' }}>
                            {step > 1 && (
                                <Button 
                                    variant="outlined" 
                                    onClick={handlePrevious} 
                                    sx={{ borderRadius: 3, fontWeight: 'bold', textTransform: 'none', px: 3, color: 'text.secondary', borderColor: '#e0e0e0' }}
                                    startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                                >
                                    Volver
                                </Button>
                            )}
                            
                            {step >= 2 && step < 4 && (
                                <Button 
                                    variant="contained" 
                                    fullWidth 
                                    onClick={handleNext} 
                                    disableElevation 
                                    sx={{ borderRadius: 3, py: 1.5, fontWeight: 'bold', fontSize: '1rem', textTransform: 'none' }}
                                >
                                    Siguiente Paso
                                </Button>
                            )}

                            {step === 4 && (
                                <LoadingButton 
                                    variant="contained" 
                                    fullWidth 
                                    disabled={reCaptcha === '' || !agree}
                                    loading={isLoading} 
                                    onClick={handleSubmit} 
                                    disableElevation 
                                    sx={{ borderRadius: 3, py: 1.5, fontWeight: 'bold', fontSize: '1rem', textTransform: 'none' }}
                                >
                                    Finalizar Registro
                                </LoadingButton>
                            )}
                        </Box>
                        
                    </Box>
                </Box>
            </Container>

            <ResponseComponent show={isOpen} title={title} success={success} message={message} handleClose={handleCloseModal} actionText="Ir a mi panel" onClick={handleCloseModal} />
            <QUDProgress open={isLoading} />
        </Box>
    );
}